import { Card, Flex, Grid, Image, Paper, Tabs } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import classes from './GameDescription.module.css';
import { GameDescriptionTabList } from './GameDescriptionTabList';
import { GameInfoPanel } from './GameInfoPanel';
import { GameKeyFuturePanel } from './GameKeyFuturePanel';
import { GameOverviewPanel } from './GameOverviewPanel';
import { GamePlayPanel } from './GamePlayPanel';
export const GameDescription: React.FC = () => {
  const isMobile = useMediaQuery('(max-width: 36em)');
  return <Paper px={{
    base: 10,
    lg: 20
  }} py={{
    base: 24,
    lg: 32
  }} bg="var(--bg-200)">
      <Tabs variant="pills" defaultValue="info" orientation={isMobile ? 'horizontal' : 'vertical'} classNames={classes}>
        <Grid w="100%">
          <Grid.Col span={{
          base: 12,
          sm: 4.5,
          md: 3.5
        }}>
            <Card w="100%" radius={5} bg="var(--bg-400)" p={{
            base: 10,
            sm: 20
          }}>
              <Flex direction={{
              base: 'row',
              sm: 'column'
            }} gap={{
              base: 10,
              sm: 24
            }}>
                <Image src="/assets/game-image.png" w={{
                base: 184,
                sm: 'auto'
              }} h={{
                base: 184,
                sm: 'auto'
              }} alt="image" radius={5} />

                <GameDescriptionTabList />
              </Flex>
            </Card>
          </Grid.Col>

          <Grid.Col span={{
          base: 12,
          sm: 7.5,
          md: 8.5
        }}>
            <Tabs.Panel value="info">
              <GameInfoPanel />
            </Tabs.Panel>
            <Tabs.Panel value="overview">
              <GameOverviewPanel />
            </Tabs.Panel>
            <Tabs.Panel value="play">
              <GamePlayPanel />
            </Tabs.Panel>
            <Tabs.Panel value="key">
              <GameKeyFuturePanel />
            </Tabs.Panel>
          </Grid.Col>
        </Grid>
      </Tabs>
    </Paper>;
};